// FeedbackNotFound.tsx — terminal state for an unknown feedback id.
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Wrap = styled.div`
  padding: 40px 20px;
  text-align: center;
  border: 1px solid ${({ theme }) => theme.color.glassBorder};
  border-radius: ${({ theme }) => theme.radius.lg};
  background: ${({ theme }) => (theme.cardsGlass ? 'transparent' : theme.color.surface)};
`;

const Title = styled.h1`
  margin: 0 0 6px;
  font-family: ${({ theme }) => theme.font.display};
  font-size: ${({ theme }) => theme.fontSize.md};
  font-weight: 700;
  color: ${({ theme }) => theme.color.textPrimary};
`;

const Blurb = styled.p`
  margin: 0 0 16px;
  font-family: ${({ theme }) => theme.font.body};
  font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.color.textMuted};
`;

const Back = styled(Link)`
  font-family: ${({ theme }) => theme.font.body};
  font-size: ${({ theme }) => theme.fontSize.sm};
  font-weight: 600;
  color: ${({ theme }) => theme.color.brandFrom};
`;

export function FeedbackNotFound() {
  return (
    <Wrap role="alert">
      <Title>Feedback not found</Title>
      <Blurb>This item doesn&apos;t exist, or it was removed.</Blurb>
      <Back to="/feedback">Back to Feedback</Back>
    </Wrap>
  );
}
